import { render } from "./FormCard.vue?vue&type=template&id=d60bd7e0&scoped=true"
import script from "./FormCard.vue?vue&type=script&lang=js"
export * from "./FormCard.vue?vue&type=script&lang=js"

import "./FormCard.vue?vue&type=style&index=0&id=d60bd7e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d60bd7e0"]])

export default __exports__